import React from 'react'
import { Switch, Route } from "react-router-dom";

import HomeBook from "../sBook/Home";
import BookCreation from '../sBook/BookCreation';
import Book from '../sBook/Book';
import BookV2 from '../sBook/V2/Book';
import BookV3 from '../sBook/V3/Book';

import Roles from '../sRoles/Index'
import HomeKPI from "../sKPI/Home";

import BoardCreation from '../sKPI/BoardCreation';
import ElementConfiguration from '../sKPI/ElementConfiguration';
import Gap from '../sKPI/Gap';
import GapV2 from '../sKPI/V2/Gap';
import Ticket from '../sTciket/Index';
//import Contract from '../Maintainers/Contract';
import Contract from '../Maintainers/Contract';
import Project from '../Maintainers/Project';
import BusinessUnit from '../Maintainers/BusinessUnit';
import LegalEntity from '../Maintainers/LegalEntity';
import Privilege from '../Maintainers/Privilege';
import MeasurementUnit from '../Maintainers/sKPI/MeasurementUnit';
import MasterKpi from '../Maintainers/sKPI/MasterKpi';
import TypeOf from '../Maintainers/sKPI/TypeOf/indexNew';
import Variable from '../Maintainers/sKPI/Variable/indexNew';

import HomeLanding from '../HomeLanding';
import Login from '../sBook/Login';
import Logout from '../sBook/Logout';
import Logoutt from '../sBook/Logoutt';
import Maintenance from '../Maintenance';
import { MAINTENCANCE } from '../../configurations/application.config';
import { __enum_SystemPages, __SystemPagesPaths, enum__PRIVILEGE_APP } from '../../common/Dictionaries';
import HomeV2 from '../sKPI/HomeV2';
import BoardConfiguration from '../sKPI/BoardConfiguration/BoardConfiguration';
import BoardConfigurationReport from '../sKPI/BoardConfiguration/BoardConfigurationReport';
import BulkUpload from '../BulkUpload';

import Board from '../sKPI/Board/BDynamic/Board';
import BoardEDP from '../sKPI/Board/BDynamic/EDP';
import BoardLanding from '../sKPI/Board/BDynamic/Landing';
import BoardLandingExternal from '../sKPI/Board/BDynamic/LandingExternal';
import BoardBusiness from '../sKPI/Board/BDynamic/Business';
import BoardPortfolio from '../sKPI/Board/BDynamic/Portfolio';
import BoardReport from '../sKPI/Board/BDynamic/Report';
import ContractModification from '../Maintainers/sKPI/ContractModification';
import Integration from '../sIntegration/Index';
import HomeLandingV2 from '../HomeLandingV2';
import ContractParties from '../sPay/ContractParties/index';

import Adjustment from '../sAdjustment';
import PrepareEdP from '../sEdP/PrepareEdP';
import ConfigureEdP from '../sEdP/ConfigureEdP';
import ContractCompare from '../sKPI/Board/BDynamic/ContractCompare';
import Increment from '../Maintainers/Pay/Increment';
import Deduction from '../Maintainers/Pay/Deduction';
import ChecklistNotaTipo from '../Maintainers/ChecklistNotaTipo';
import PartieType from '../Maintainers/sKPI/PartieType';
import PartieUnit from '../Maintainers/sKPI/PartieUnit';
import PolinomyType from '../Maintainers/sKPI/PolinomyType';
import NotificationTasks from '../sNotificationTasks/Index';
import Currency from '../Maintainers/sKPI/Currency';
import DocumentTeach from '../sDocumentTeach/index';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../common/Helpers';
import NotFound from '../../components/Templates/Site/NotFound';
import PowerBI from '../sKPI/Board/BDynamic/PowerBI';
import Obligation from '../Maintainers/Obligation';
import ObligationCategory from '../Maintainers/ObligationCategory';
import ObligationInconsistency from '../Maintainers/ObligationInconsistency';
import ElementObligations from '../sObligationControl/ElementObligations';
import HomeObligations from '../sObligationControl/HomeObligations';
//import PruebaMessageTemplate from '../PruebaMessageTemplate';
import DitributionGroups from '../Maintainers/Book/DitributionGroups';
import MessageTopic from '../Maintainers/Book/MessageTopic';
import NotDataAccess from '../NotDataAccess';
import JobPosition from '../Maintainers/Job';

const siteInMaintenance = MAINTENCANCE

function Router(props) {
  
    const inputParam_Products = props.products !== undefined && props.products !== null ? props.products : [];
    const inputParam_Profiles= props.profiles !== undefined && props.profiles !== null ? props.profiles : [];

    let arrayRoutes = [];
    

    //Book
    if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.BOOK)) {
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.HomeBook].text}`, component:HomeBook })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.HomeBook].text}/:contractCode`, component:HomeBook })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}`, component:BookCreation })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}/:bookId`, component:BookCreation })
        //[#NEW31082026#]SE COMENTA POR QUE LAS OTRAS VERSIONES TIENEN PROBLEMAS. Se enruta a BookV3 sin borrar Book/BookV2.
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Book].text}`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Book].text}/:bookId`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Book].text}/:bookId/:messageId`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookV2].text}`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookV2].text}/:bookId`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookV2].text}/:bookId/:messageId`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookV3].text}`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/:bookId`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/:bookId/:messageId`, component:BookV3 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.DitributionGroups].text}`, component:DitributionGroups })
    }
    

    //CO
    if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.CO)) {
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ElementObligations].text}/:elementId/:obligationIdSelected`, component:ElementObligations })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.HomeObligations].text}`, component:HomeObligations })
    }

    
    //KPI GAP Transversal Boards
    if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.KPI)) {
        //KPI
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.HomeKPI].text}`, component:HomeKPI })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.HomeKPIV2].text}`, component:HomeV2 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardCreation].text}`, component:BoardCreation })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardCreation].text}/:boardId`, component:BoardCreation })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ElementConfiguration].text}`, component:ElementConfiguration })


        //GAP
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Gap].text}`, component:Gap })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Gap].text}/:GAPId`, component:Gap })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.GapV2].text}`, component:GapV2 })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.GapV2].text}/:elementId`, component:GapV2 })


        //Transversal Boards
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardPortfolio].text}`, component:BoardPortfolio })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardBusiness].text}/:elementId`, component:BoardBusiness })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Board].text}/:elementId/:boardTypeId`, component:Board })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardReport].text}/:elementId`, component:BoardReport })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PowerBI].text}/:elementId`, component:PowerBI })
    }


    //Pay
    if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.EDP)) {
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ContactParties].text}/:elementId`, component:ContractParties })  
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ConfigureEdP].text}/:elementId`, component:ConfigureEdP })  
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PrepareEdP].text}/:elementId/:edpId`, component:PrepareEdP })  
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardEDP].text}/:elementId`, component:BoardEDP })
    }


    if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0)
    {
        if (inputParam_Products.includes(enum__PRIVILEGE_APP.BOOK) && !inputParam_Products.includes(enum__PRIVILEGE_APP.KPI)) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardLanding].text}`, component:HomeBook })
        }
        else if (inputParam_Products.includes(enum__PRIVILEGE_APP.BOOK) && inputParam_Products.includes(enum__PRIVILEGE_APP.KPI)) {
            if (!isNullUndefined(inputParam_Profiles.find(x => x !== "External"))) {
                arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardLanding].text}`, component:BoardLanding })
            }
            else {
                arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardLandingExternal].text}`, component:BoardLandingExternal })
            }
        }
        else {
            if (!isNullUndefined(inputParam_Profiles.find(x => x !== "External"))) {
                arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardLanding].text}`, component:BoardLanding })
            }
            else {
                arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardLandingExternal].text}`, component:BoardLandingExternal })
            }
        }
    }
    else {
        if (!isNullUndefined(inputParam_Profiles.find(x => x !== "External"))) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardLanding].text}`, component:BoardLanding })
        }
        else {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BoardLandingExternal].text}`, component:BoardLandingExternal })
        }
    }

    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ConfigurationReport].text}`, component:BoardConfigurationReport })
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ConfigurationBoard].text}`, component:BoardConfiguration })


    //Roles
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Roles].text}/:elementId`, component:Roles })


    //Adjustment
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Adjustments].text}`, component:Adjustment }) 


    //TCH Report
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ContractCompare].text}`, component:ContractCompare })  


    //System Transversal
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Ticket].text}`, component:Ticket })
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.NotificationTasks].text}`, component:NotificationTasks })  
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.DocumentTeach].text}`, component:DocumentTeach }) 
    arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.NoDataAccess].text}`, component:NotDataAccess }) 

    
    if (!isNullUndefined(inputParam_Profiles.find(x => x === "sAdmin")) || !isNullUndefined(inputParam_Profiles.find(x => x === "Admin"))) {
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Integration].text}`, component:Integration })  
    }


    // "Contratos / Obligaciones incongruentes": solo Super Administrador (sAdmin). Quien no lo sea ve la pantalla de "Error de acceso" (NotDataAccess).
    const isSAdminProfile = !isNullUndefined(inputParam_Profiles.find(x => x === "sAdmin"));

    //Mantainers
    if (!isNullUndefined(inputParam_Profiles.find(x => x === "sAdmin")) || !isNullUndefined(inputParam_Profiles.find(x => x === "Admin")) || !isNullUndefined(inputParam_Profiles.find(x => x === "Observador"))) {
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.MessageTopic].text}`,          component:MessageTopic })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Contract].text}`,              component:Contract })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Project].text}`,               component:Project })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.LegalEntity].text}`,           component:LegalEntity })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BusinessUnit].text}`,          component:BusinessUnit })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Privilege].text}`,             component:Privilege })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.JobPosition].text}`,           component:JobPosition })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BulkUpload].text}/`,           component:BulkUpload })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BulkUpload].text}/:elementId`, component:BulkUpload })
        
        if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.CO)) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Obligation].text}`,            component: Obligation })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ObligationCategory].text}`,    component: ObligationCategory })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ObligationInconsistency].text}`, component: isSAdminProfile ? ObligationInconsistency : NotDataAccess })
        }

        if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.KPI)) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.MeasurementUnit].text}`,       component:MeasurementUnit })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.MasterKpi].text}`,             component:MasterKpi })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.TypeOf].text}`,                component:TypeOf })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Variable].text}`,              component:Variable })
        }

        if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.EDP)) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ContractModification].text}`,  component:ContractModification })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Increment].text}`,             component:Increment })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Deduction].text}`,             component:Deduction })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PolinomyType].text}`,          component:PolinomyType })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PartieType].text}`,            component:PartieType })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PartieUnit].text}`,            component:PartieUnit })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ChecklistNotaTipo].text}`,     component:ChecklistNotaTipo })
        }

        //arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Currency].text}`, component:Currency })
    }
    else {
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Contract].text}`,              component: NotFound })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Project].text}`,               component: NotFound })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.LegalEntity].text}`,           component: NotFound })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BusinessUnit].text}`,          component: NotFound })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Privilege].text}`,             component: NotFound })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BulkUpload].text}/`,           component: NotFound })
        arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.BulkUpload].text}/:elementId`, component: NotFound })

        if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.CO)) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Obligation].text}`,            component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ObligationCategory].text}`,    component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ObligationInconsistency].text}`, component: NotDataAccess })
        }

        if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.KPI)) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.MeasurementUnit].text}`,       component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.MasterKpi].text}`,             component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.TypeOf].text}`,                component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Variable].text}`,              component: NotFound })
        }

        if (!isNullUndefinedOrEmpty(inputParam_Products) && inputParam_Products.length > 0 && inputParam_Products.includes(enum__PRIVILEGE_APP.EDP)) {
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ContractModification].text}`,  component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Increment].text}`,             component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Deduction].text}`,             component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PolinomyType].text}`,          component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PartieType].text}`,            component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.PartieUnit].text}`,            component: NotFound })
            arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.ChecklistNotaTipo].text}`,     component: NotFound })
        }

        //arrayRoutes.push({ path:`${__SystemPagesPaths[__enum_SystemPages.Currency].text}`, component:NotFound })
    }

    return (
        <>
            {
                !siteInMaintenance &&
                <Switch>
                    {
                        arrayRoutes.map((route, index) => (  
                            <Route key={index} exact path={route.path}  component={route.component} />
                        ))
                    }
                    <Route exact path={`${__SystemPagesPaths[__enum_SystemPages.HomeLanding].text}`} component={HomeLanding} />
                    <Route exact path={`${__SystemPagesPaths[__enum_SystemPages.HomeLandingV2].text}`} component={HomeLandingV2} />
                    <Route exact path={`${__SystemPagesPaths[__enum_SystemPages.Login].text}`} component={Login} />
                    <Route exact path={`${__SystemPagesPaths[__enum_SystemPages.Logout].text}`} component={Logout} />
                    <Route exact path={`${__SystemPagesPaths[__enum_SystemPages.Logoutt].text}`} component={Logoutt} />
                </Switch>
            }
            {
                siteInMaintenance &&
                <Switch>
                    <Route exact path="/" component={Maintenance} />
                    <Route exact path={`${__SystemPagesPaths[__enum_SystemPages.Maintenance].text}`} component={Maintenance} />
                </Switch>
            }
        </>
    );
}
export default Router;
